// helpers
import { humanizeDateRange } from 'lib/helpers/dates'

const LocationOpenDates = props => {
  const { openDate, closeDate } = props

  // Temporary hack for 2021
  if (openDate === '2021-06-01' && closeDate === '2021-08-31') {
    return 'Dates TBD'
  }

  return humanizeDateRange(openDate, closeDate)
}

export default LocationOpenDates
